import { NAMESPACE } from '../../lib/constants';
export const types = {
    REQUEST_EXPERIMENT: `${NAMESPACE}/REQUEST_EXPERIMENT`,
    SKIP_EXPERIMENT: `${NAMESPACE}/SKIP_EXPERIMENT`,
    SET_EXPERIMENTS: `${NAMESPACE}/SET_EXPERIMENTS`,
    FETCH_EXPERIMENT: {
        REQUEST: `${NAMESPACE}/FETCH_EXPERIMENT/REQUEST`,
        SUCCESS: `${NAMESPACE}/FETCH_EXPERIMENT/SUCCESS`,
        ERROR: `${NAMESPACE}/FETCH_EXPERIMENT/ERROR`,
    },
};
//# sourceMappingURL=types.js.map